import Alpine from "alpinejs";
window.Alpine = Alpine
Alpine.start();


import carousels from "./scripts/carousels";
import animations from "./scripts/animations";
import galleries from "./scripts/galleries";
